import { createRouter ,createWebHashHistory } from 'vue-router'
// Views
import PoolSelect from '../views/PoolSelect'
import Customizer from '../views/Customizer'
import SummaryView from '../views/SummaryView'


const routerPrefix = '';
const routes = [
  // On page load, start at choose pool
  { path: routerPrefix + '/', redirect: '/select-pool' },
  {
    path: routerPrefix + '/select-pool/', component: PoolSelect,
  },
  {
    path: routerPrefix + '/customizer',
    component: Customizer,
    beforeEnter: (to, from, next) => {
      if (from.path === '/summary') {
        window.moveCanvasOutOfSummary();
      }

      next();
    },
  },
  {
    path: routerPrefix + '/summary',
    component: SummaryView,
  },
]

const router = createRouter({
  routes,
  history: createWebHashHistory()
});

export default router
